module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-call_gray.2a847c1b.svg";